<p class="reminder">Please add <strong>country name</strong> to the URL path to continue.</p>